import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import * as XLSX from "xlsx"; // Import for Excel download
import { recruiterListAPI, deleteRecruiter } from "../../api/recruiter";
import NewR from "./NewR";
import EditR from "./EditR";
import moment from "moment";
import { Modal } from "react-bootstrap";
import _ from "lodash";
import { getReasonList } from "../../api/candidate";
import DataTable from "react-data-table-component";
import SearchInputComponent from "../App/Common/SearchInputComponent";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { categoryPlanListAPI } from "../../api/plan";

const RLists = () => {
  const [addCard, setAddCard] = useState(false);
  const [Events, setEvents] = useState([]);
  const [recruiterType] = useState([
    { id: 1, name: "Regular Recruiter" },
    { id: 2, name: "Internship Recruiter" },
  ]);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "none",
  });
  const [filter, setFilter] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10); // State for rows per page
  const [hasMore, setHasMore] = useState(true);
  const [totalEntries, setTotalEntries] = useState(0);
  const [reason, setReason] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const AdvanceSearchFields = useMemo(() => {
    return {
      start_date: "",
      end_date: "",
      published: "",
      category_id: "",
      plan_id: "",
      recruiter_type: "",
    };
  });

  const SearchFields = useMemo(() => {
    return {
      ...AdvanceSearchFields,
    };
  }, []);

  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRow, setSelectedRows] = useState([]);
  const [fetch, setFetch] = useState(true);
  const [addModel, setAddModal] = useState(false);
  const [advFields, setAdvFields] = useState(SearchFields);
  const [advanceParams, setAdvanceParams] = useState(SearchFields);
  const [clearAdvanceSearch, setClearAdvanceSearch] = useState(false);
  const [data, setData] = useState([]);

  const [categories, setCategoties] = useState([]);
  const [plnList, setPlnList] = useState([]);

  const navigate = useNavigate();

  const [reqParams, setReqParams] = useState({
    ...SearchFields,
    page: currentPage,
    limit: perPage,
    sort_by: "created_at",
    sort_direction: "DESC",
  });

  const dateDifference = useCallback((dateA, dateB) => {
    const date1 = new Date(dateA);
    const date2 = new Date(dateB);

    const timeDiff = Math.abs(date2 - date1);
    const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    return daysDiff;
  }, []);

  const calculateDays = useCallback((formdata, total = false) => {
    let difference = 0;
    if (
      formdata?.extension_date !== "" &&
      formdata?.extension_date > formdata?.plan_expire_date
    ) {
      difference = dateDifference(
        formdata?.plan_expire_date,
        formdata?.extension_date
      );
    }
    if (total) {
      difference += dateDifference(
        formdata?.plan_start_date,
        formdata?.plan_expire_date
      );
      return difference;
    } else {
      return difference;
    }
  }, []);

  const columns = useMemo(() => {
    return [
      {
        name: "Actions",
        selector: (row) => (
          <div className="d-flex justify-content-end">
            <div title="Manage Sub Recruiter" className="mr-2">
              <Link
                to={"#"}
                onClick={(e) => handleSubRClick(e, row.id)}
                className="btn btn-secondary light"
              >
                MSR
              </Link>
            </div>
            <div title="View Jobs" className="ms-2">
              <Link
                to={"#"}
                className="btn btn-secondary light mr-2"
                onClick={(e) => handleJobsClick(e, row.id)}
              >
                View Jobs
              </Link>
            </div>

            <div className="action-buttons d-flex justify-content-end">
              <Link
                to={"/" + row.id + "/plan-history"}
                className="btn btn-warning light mr-2"
                //onClick={() => handleEditClick(row.id)}
              >
                <i className="fa fa-history"></i>
              </Link>
              <Link
                to={"#"}
                className="btn btn-secondary light mr-2"
                onClick={() => handleEditClick(row.id)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  className="svg-main-icon"
                >
                  <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24"></rect>
                    <path
                      d="M8,17.9148182 L8,5.96685884 C8,5.56391781 8.16211443,5.17792052 8.44982609,4.89581508 L10.965708,2.42895648 C11.5426798,1.86322723 12.4640974,1.85620921 13.0496196,2.41308426 L15.5337377,4.77566479 C15.8314604,5.0588212 16,5.45170806 16,5.86258077 L16,17.9148182 C16,18.7432453 15.3284271,19.4148182 14.5,19.4148182 L9.5,19.4148182 C8.67157288,19.4148182 8,18.7432453 8,17.9148182 Z"
                      fill="#000000"
                      fillRule="nonzero"
                      transform="translate(12.000000, 10.707409) rotate(-135.000000) translate(-12.000000, -10.707409) "
                    ></path>
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="5"
                      y="20"
                      width="15"
                      height="2"
                      rx="1"
                    ></rect>
                  </g>
                </svg>
              </Link>
              <Link
                to={"#"}
                className="btn btn-danger light"
                onClick={() => handleDeleteClick(row.id)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  className="svg-main-icon"
                >
                  <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24"></rect>
                    <path
                      d="M6,8 L6,20.5 C6,21.3284271 6.67157288,22 7.5,22 L16.5,22 C17.3284271,22 18,21.3284271 18,20.5 L18,8 L6,8 Z"
                      fill="#000000"
                      fillRule="nonzero"
                    ></path>
                    <path
                      d="M14,4.5 L14,4 C14,3.44771525 13.5522847,3 13,3 L11,3 C10.4477153,3 10,3.44771525 10,4 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z"
                      fill="#000000"
                      opacity="0.3"
                    ></path>
                  </g>
                </svg>
              </Link>
            </div>
          </div>
        ),
        wrap: true,
        width: "330px",
      },
      {
        name: "R.ID",
        selector: (row) => row.id,
        sortable: true,
        sortField: "id",
      },
      {
        name: "Name",
        selector: (row) => row.name,
        wrap: true,
        width: "140px",
        sortable: true,
        sortField: "name",
      },
      {
        name: "Company",
        selector: (row) => row.company_name,
        wrap: true,
        width: "160px",
        sortable: true,
        sortField: "company_name",
      },
      {
        name: "Email",
        selector: (row) => row.email,
        wrap: true,
        width: "200px",
        sortable: true,
        sortField: "email",
      },
      {
        name: "Type",
        selector: (row) =>
          row.recruiter_type
            ?.split(",")
            .map((it) => recruiterType[it - 1].name)
            .join(", "),
        wrap: true,
        width: "100px",
        sortable: true,
        sortField: "recruiter_type",
      },
      {
        name: "Created Time",
        selector: (row) => row.created_at,
        wrap: true,
        width: "165px",
        sortable: true,
        sortField: "created_at",
      },
      {
        name: "Created By",
        selector: (row) => row.created_by_name,
        wrap: true,
        width: "120px",
        sortable: true,
        sortField: "created_by_name",
      },
      {
        name: "Until",
        selector: (row) => row.plan_expire_date,
        wrap: true,
        width: "120px",
        sortable: true,
        sortField: "plan_expire_date",
      },
      {
        name: "Total Unlock Quota",
        selector: (row) => row.total_unlock_quota,
        wrap: true,
        width: "170px",
        sortable: true,
        sortField: "total_unlock_quota",
      },
      {
        name: "Total Unlocked Quota",
        selector: (row) => row.total_unlocked_remaining,
        wrap: true,
        width: "180px",
        sortable: true,
        sortField: "total_unlocked_remaining",
      },
      {
        name: "General Unlock Quota",
        selector: (row) => row.general_unlock_quota,
        wrap: true,
        width: "185px",
        sortable: true,
        sortField: "general_unlock_quota",
      },
      {
        name: "General Unlocked",
        selector: (row) => row.general_unlocked_remaining,
        wrap: true,
        width: "160px",
        sortable: true,
        sortField: "general_unlocked_remaining",
      },
      {
        name: "Total Applicants",
        selector: (row) => row.total_applicants,
        wrap: true,
        width: "150px",
        sortable: true,
        sortField: "total_applicants",
      },
      {
        name: "Applicants Unlock Quota",
        selector: (row) => row.applicants_unlock_quota,
        wrap: true,
        width: "200px",
        sortable: true,
        sortField: "applicants_unlock_quota",
      },
      {
        name: "Applicants Unlocked",
        selector: (row) => row.applicants_unlocked_remaining,
        wrap: true,
        width: "180px",
        sortable: true,
        sortField: "applicants_unlocked_remaining",
      },
      {
        name: "Posted Jobs",
        selector: (row) => row.posted_jobs_remaining,
        wrap: true,
        width: "130px",
        sortable: true,
        sortField: "posted_jobs_remaining",
      },
      {
        name: "Sub Recruiter Quota",
        selector: (row) => row.sub_recruiter_quota,
        wrap: true,
        width: "180px",
        sortable: true,
        sortField: "sub_recruiter_quota",
      },
      {
        name: "Sub Recruiter Created",
        selector: (row) => row.subrecruiter_remaining_quota,
        wrap: true,
        width: "190px",
        sortable: true,
        sortField: "subrecruiter_remaining_quota",
      },
      {
        name: "Offers",
        selector: (row) => row.offers,
        wrap: true,
        width: "90px",
        sortable: true,
        sortField: "offers",
      },
      {
        name: "Remaining Days",
        selector: (row) => row.days_remaining,
        wrap: true,
        width: "155px",
        sortable: true,
        sortField: "days_remaining",
      },
      {
        name: "Plan Start Date",
        selector: (row) => row.plan_start_date,
        wrap: true,
        width: "180px",
        sortable: true,
        sortField: "plan_start_date",
      },
      {
        name: "Menus",
        selector: (row) => row.menu_names,
        wrap: true,
        width: "230px",
        //sortable: true,
        //sortField: "plan_start_date",
      },
      {
        name: "Plan Category",
        selector: (row) => row.category_name,
        wrap: true,
        width: "120px",
        //sortable: true,
        //sortField: "plan_start_date",
      },
      {
        name: "Plan Name",
        selector: (row) => row.plan_name,
        wrap: true,
        width: "100px",
        //sortable: true,
        //sortField: "plan_start_date",
      },
      {
        name: "Job Posting Date",
        selector: (row) => row.job_posting_date,
        wrap: true,
        width: "140px",
        //sortable: true,
        //sortField: "plan_start_date",
      },
      {
        name: "Resume Access Date",
        selector: (row) => row.resume_access_date,
        wrap: true,
        width: "160px",
        //sortable: true,
        //sortField: "plan_start_date",
      },
      {
        name: "Extantion Date",
        selector: (row) => row.extension_date,
        wrap: true,
        width: "120px",
        //sortable: true,
        //sortField: "plan_start_date",
      },
      {
        name: "Extantion Days",
        selector: (row) => calculateDays(row),
        wrap: true,
        width: "130px",
        //sortable: true,
        //sortField: "plan_start_date",
      },
      {
        name: "Total Access",
        selector: (row) => calculateDays(row, true),
        wrap: true,
        width: "130px",
        //sortable: true,
        //sortField: "plan_start_date",
      },
      {
        name: "Status",
        selector: (row) => (
          <span
            className={`badge badge-lg light badge-${
              row.published == "1" ? "success" : "danger"
            }`}
          >
            {row.published == "1" ? "Active" : "InActive"}
          </span>
        ),
        sortable: true,
        sortField: "published",
        wrap: true,
        width: "120px",
      },
    ];
  }, [calculateDays]);

  const fetchCategory = useCallback(() => {
    categoryPlanListAPI().then((res) => {
      //setCategoties(res)
      let catPlans = {};
      res.forEach((element) => {
        catPlans[element.category_id] = {
          name: element.name,
          plans: element.plans,
        };
      });
      setCategoties(catPlans);
    });
  }, []);

  const fetchUsers = useCallback(
    (params) => {
      params = {
        ...params,
        registered_after:
          params.registered_after !== ""
            ? moment(params?.registered_after).format("yyyy-MM-DD")
            : "",
        registered_before:
          params.registered_before !== ""
            ? moment(params?.registered_before).format("yyyy-MM-DD")
            : "",
      };
      setToggleCleared(!toggleCleared);
      setLoading(true);
      // jobListAPI(params)
      recruiterListAPI(params)
        .then((res) => {
          setData(res?.data);
          setTotalRows(res?.total);
          setLoading(false);
          setFetch(false);
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          //console.log(err);
          setLoading(false);
          setFetch(false);
        });
    },
    [setFetch, toggleCleared]
  );

  useEffect(() => {
    fetchCategory();
  }, [fetchCategory]);

  useEffect(() => {
    if (fetch) {
      let reqData = {};
      if (clearAdvanceSearch) {
        reqData = { ...reqParams, ...advanceParams };
      } else {
        reqData = { ...advanceParams, ...reqParams };
      }
      fetchUsers(reqData);
    }
  }, [fetch, reqParams, advanceParams, clearAdvanceSearch]);

  const handleCopy = () => {
    const text = data.map((job) => Object.values(job).join("\t")).join("\n");
    navigator.clipboard.writeText(text).then(() => {
      swal("Copied!", "Table data copied to clipboard.", "success");
    });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Jobs");
    XLSX.writeFile(workbook, "RecuiterList.xlsx");
  };

  const reportColumn = useMemo(
    () => ({
      plan_name: "Sponsor",
      company_name: "Company",
      extension_date: "Portal Access End Date",
      resume_access_date: "Resume Portal Access Date",
      total_access: "Access Number Of days",
      job_posting_date: "Job Posting Access Date",
      jobs_limit: "Total Job Posts Quota",
      posted_jobs_remaining: "Jobs Posted",
      general_unlock_quota: "Resume Unlock Quota (General)",
      general_unlocked_remaining: "General Unlocked",
      applicants_unlock_quota: "Applicant Download Quota",
      applicants_unlocked_remaining: "Applicants Unlocked",
      total_applicants: "Total Number of Applicants",
      offers: "No of Offers",
    }),
    []
  );

  const downlodReportExecl = useCallback(() => {
    const reportArray = [];
    if (data.length > 0) {
      data.forEach((element) => {
        let reportRow = {};
        Object.keys(reportColumn).map((e) => {
          reportRow[reportColumn[e]] =
            element[e] !== undefined ? element[e] : "";
        });
        reportArray.push(reportRow);
      });
    }
    const worksheet = XLSX.utils.json_to_sheet(reportArray);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Jobs");
    XLSX.writeFile(workbook, "RecuiterReport.xlsx");
  }, [reportColumn, data]);

  const reasonOptionList = useCallback((reason) => {
    var span = document.createElement("span");
    let list = "<option value=''>Select Reason</option>";
    if (reason) {
      for (let index = 0; index < reason.length; index++) {
        const res = reason[index];
        list +=
          `<option value="` +
          res.id +
          `" key="` +
          index +
          `"}>` +
          res.reason +
          `</option>`;
      }
    }
    span.innerHTML =
      `<select id="reason" class="form-control">` + list + `</select>`;
    return span;
  }, []);

  // Delete data
  const handleDeleteClick = async (contactId) => {
    getReasonList(2).then(async (res) => {
      //setReason(res);
      const span = reasonOptionList(res);
      var candidate;
      if (contactId) {
        candidate = [contactId];
      } else {
        const jobsIds = selectedRow.map((c, i) => {
          return c.id;
        });
        candidate = jobsIds;
      }
      if (candidate.length < 1) {
        swal("Opps", "Please select at least 1 job to delete.", "error");
        return false;
      }

      const willDelete = await swal({
        title: "Are you sure?",
        text: "Are you sure that you want to delete this record?",
        icon: "warning",
        dangerMode: true,
        buttons: true,
        content: span,
      });

      if (willDelete) {
        let postData = {
          reason_id: document.getElementById("reason").value,
          ids: candidate.join(","),
        };

        //let res = await deleteRecruiter(contactId);
        let res = await deleteRecruiter(postData);
        if (res?.error) {
          swal("Oops", res.error, "error");
        } else {
          //setSelectAll(false);
          setSelectedRows([]);
          setToggleCleared(!toggleCleared);
          setLoading(true);
          setFetch(true);
          swal("Deleted!", "Record has been deleted!", "success");
        }
      }
    });
  };

  // Edit start
  const [editModal, setEditModal] = useState(false);
  const [editContactId, setEditContactId] = useState(null);

  // Edit function button click to edit
  const handleEditClick = async (id) => {
    setEditContactId(id);
    setEditModal(true);
  };

  const renderSortIcon = (key) => {
    if (sortConfig.key === key) {
      if (sortConfig.direction === "asc") {
        return <span>▲</span>;
      } else if (sortConfig.direction === "desc") {
        return <span>▼</span>;
      }
    }
    return <span>↕</span>;
  };

  const handleJobsClick = (e, recruiter_id) => {
    e.preventDefault();
    localStorage.setItem("recruiter_id", recruiter_id);
    localStorage.removeItem("subrecruiter_id");
    navigate("/job_list?type=recruiter");
  };

  const handleSubRClick = (e, recruiter_id) => {
    e.preventDefault();
    localStorage.setItem("rid", recruiter_id);
    navigate("/sub_recruiter_list");
  };

  const renderPagination = () => (
    <div className="d-md-flex d-block align-items-center justify-content-between text-center flex-wrap mt-md-0 mt-3">
      <div className="mb-md-0 mb-2">
        <h5 className="mb-0">
          Showing {Math.min((page - 1) * rowsPerPage + 1, totalEntries)} to{" "}
          {Math.min(page * rowsPerPage, totalEntries)} of {totalEntries} entries
        </h5>
      </div>
      <nav>
        <ul className="pagination pagination-circle justify-content-center">
          <li className="page-item page-indicator">
            <Link
              to="#"
              className="page-link"
              onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
              disabled={page === 1}
            >
              <i className="fa fa-angle-double-left" />
            </Link>
          </li>
          <li className="page-item active">
            <Link to="#" className="page-link">
              {page}
            </Link>
          </li>
          <li className="page-item page-indicator">
            <Link
              to="#"
              className="page-link"
              onClick={() => setPage((prev) => (hasMore ? prev + 1 : prev))}
              disabled={!hasMore}
            >
              <i className="fa fa-angle-double-right" />
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );

  const handleCheckboxChange = (id) => {
    setSelectedJobs((prev) =>
      prev.includes(id) ? prev.filter((jobId) => jobId !== id) : [...prev, id]
    );
  };

  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);
    setSelectedJobs(isChecked ? Events.map((job) => job.id) : []);
  };

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      setReqParams({
        ...reqParams,
        page: page,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page) => {
      setPerPage(newPerPage);
      setReqParams({
        ...reqParams,
        limit: newPerPage,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleSort = useCallback(
    (column, sortDirection) => {
      if (column?.sortField !== undefined) {
        setReqParams({
          ...reqParams,
          sort_by: column.sortField,
          sort_direction: sortDirection,
        });
        setFetch(true);
      }
    },
    [reqParams, setReqParams, setFetch]
  );

  const handleSearchText = useCallback(
    (text, isClear = false) => {
      if (text || isClear) {
        setReqParams((state) => {
          return { ...state, keyword: text };
        });
        setFetch(true);
      }
    },
    [setReqParams, setFetch]
  );

  const onSaveAdvanceSearch = useCallback(() => {
    setReqParams({
      ...reqParams,
      page: 1,
    });
    setAdvanceParams({
      ...advFields,
      start_date:
        advFields.start_date !== ""
          ? moment(advFields?.start_date).format("yyyy-MM-DD")
          : "",
      end_date:
        advFields.end_date !== ""
          ? moment(advFields?.end_date).format("yyyy-MM-DD")
          : "",
    });
    setClearAdvanceSearch(true);
    setAddModal(false);
    setFetch(true);
  }, [
    setReqParams,
    reqParams,
    setAdvanceParams,
    advFields,
    setFetch,
    setClearAdvanceSearch,
    setAddModal,
  ]);

  const onClearAdvanceSearch = useCallback(() => {
    setReqParams({ ...reqParams, page: 1 });
    setClearAdvanceSearch(false);
    setAdvFields(SearchFields);
    setAdvanceParams(SearchFields);
    setFetch(true);
  }, [
    setReqParams,
    reqParams,
    setClearAdvanceSearch,
    SearchFields,
    setAdvanceParams,
    setAdvFields,
    setFetch,
  ]);

  const planById = useCallback(
    (id) => {
      if (categories[id]?.plans !== undefined) {
        setPlnList(categories[id]?.plans);
      }
    },
    [categories]
  );

  useEffect(() => {
    if (advFields?.category_id) {
      planById(advFields?.category_id);
    }
  }, [advFields?.category_id]);

  return (
    <>
      <div className="d-flex align-items-center mb-4 flex-wrap">
        <h4 className="fs-20 font-w600 me-auto">{""}</h4>
        {clearAdvanceSearch && (
          <button
            onClick={onClearAdvanceSearch}
            className="btn btn-danger me-3 btn-sm"
          >
            <i className="fas fa-times me-1"></i>Reset
          </button>
        )}
        <button
          onClick={() => setAddModal(true)}
          className="btn btn-info me-3 btn-sm"
        >
          <i className="fas fa-search me-1"></i>Search
        </button>
        <div className="d-flex">
          <Link
            to={"#"}
            className="btn btn-primary btn-sm"
            onClick={() => setAddCard(true)}
          >
            <i className="fas fa-plus me-2"></i>Add New Recruiter
          </Link>
        </div>
        <NewR addCard={addCard} setAddCard={setAddCard} dataFetch={setFetch} />
        <EditR
          editModal={editModal}
          setEditModal={setEditModal}
          dataFetch={setFetch}
          editid={editContactId}
          setEditContactId={setEditContactId}
        />
      </div>

      <div className="row">
        <div className="col-xl-12">
          <div className="row mb-2">
            <div className="col-xl-10">
              <button
                className="btn btn-danger btn-sm me-3"
                onClick={() => handleDeleteClick("")}
              >
                <i className="fa fa-trash"></i> Delete
              </button>
              <button
                className="btn btn-secondary btn-sm me-3"
                onClick={handleCopy}
              >
                COPY
              </button>
              <button
                className="btn btn-warning btn-sm"
                onClick={handleDownloadExcel}
              >
                Download Excel
              </button>
              <button
                className="btn ms-3 btn-info btn-sm"
                onClick={downlodReportExecl}
              >
                Download Report
              </button>
            </div>
            {/* <div className="col-xl-2">
              <select
                className="form-select w-100 me-3"
                value={rowsPerPage}
                onChange={handleRowsPerPageChange}
              >
                {[10, 25, 50, 100, 1000, 2000].map((size) => (
                  <option key={size} value={size}>
                    Show {size}
                  </option>
                ))}
              </select>
            </div> */}
          </div>

          <div className="table-responsive">
            {/* <table className="table display mb-4 dataTablesCard Plan-table table-responsive-xl card-table dataTable no-footer">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th>R.ID</th>
                  <th onClick={() => handleSort("name")}>
                    Name {renderSortIcon("name")}
                  </th>
                  <th onClick={() => handleSort("company_name")}>
                    Company {renderSortIcon("company_name")}
                  </th>
                  <th>Email</th>
                  <th onClick={() => handleSort("recruiter_type")}>
                    Type {renderSortIcon("recruiter_type")}
                  </th>
                  <th onClick={() => handleSort("created_at")}>
                    Created Time {renderSortIcon("created_at")}
                  </th>

                  <th onClick={() => handleSort("created_by_name")}>
                    Created By {renderSortIcon("created_by_name")}
                  </th>
                  <th onClick={() => handleSort("plan_expire_date")}>
                    Until {renderSortIcon("plan_expire_date")}
                  </th>
                  <th onClick={() => handleSort("total_unlock_quota")}>
                    Total Unlock Quota {renderSortIcon("total_unlock_quota")}
                  </th>
                  <th onClick={() => handleSort("total_unlocked_remaining")}>
                    Total Unlocked Quota{" "}
                    {renderSortIcon("total_unlocked_remaining")}
                  </th>
                  <th onClick={() => handleSort("general_unlock_quota")}>
                    General Unlock Quota{" "}
                    {renderSortIcon("general_unlock_quota")}
                  </th>
                  <th onClick={() => handleSort("general_unlocked_remaining")}>
                    General Unlocked{" "}
                    {renderSortIcon("general_unlocked_remaining")}
                  </th>
                  <th onClick={() => handleSort("applicants_unlock_quota")}>
                    Applicants Unlock Quota{" "}
                    {renderSortIcon("applicants_unlock_quota")}
                  </th>
                  <th
                    onClick={() => handleSort("applicants_unlocked_remaining")}
                  >
                    Applicants Unlocked{" "}
                    {renderSortIcon("applicants_unlocked_remaining")}
                  </th>
                  <th onClick={() => handleSort("posted_jobs_remaining")}>
                    Posted Jobs {renderSortIcon("posted_jobs_remaining")}
                  </th>
                  <th onClick={() => handleSort("sub_recruiter_quota")}>
                    Sub Recruiter Quota {renderSortIcon("sub_recruiter_quota")}
                  </th>
                  <th
                    onClick={() => handleSort("subrecruiter_remaining_quota")}
                  >
                    Sub Recruiter Created{" "}
                    {renderSortIcon("subrecruiter_remaining_quota")}
                  </th>
                  <th
                  //onClick={() => handleSort("offers")}
                  >
                    Offers {renderSortIcon("offers")}
                  </th>
                  <th //onClick={() => handleSort("days_remaining")}
                  >
                    Remaining Days {renderSortIcon("days_remaining")}
                  </th>

                  <th onClick={() => handleSort("plan_start_date")}>
                    Plan Start Date {renderSortIcon("plan_start_date")}
                  </th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {Events?.length > 0 ? (
                  Events?.map((Event, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedJobs.includes(Event.id)}
                          onChange={() => handleCheckboxChange(Event.id)}
                        />
                      </td>
                      <td>{Event.id}</td>
                      <td>{Event?.name}</td>
                      <td>{Event?.company_name}</td>
                      <td>{Event.email}</td>
                      <td>
                        {Event.recruiter_type
                          ?.split(",")
                          .map((it) => recruiterType[it - 1].name)
                          .join(", ")}
                      </td>
                      <td>{Event.created_at}</td>
                      <td>{Event.created_by_name}</td>
                      <td>{Event.plan_expire_date}</td>
                      <td>{Event.total_unlock_quota}</td>
                      <td>{Event.total_unlocked_remaining}</td>
                      <td>{Event.general_unlock_quota}</td>
                      <td>{Event.general_unlocked_remaining}</td>
                      <td>{Event.applicants_unlock_quota}</td>
                      <td>{Event.applicants_unlocked_remaining}</td>
                      <td>{Event.posted_jobs_remaining}</td>
                      <td>{Event.sub_recruiter_quota}</td>
                      <td>{Event.subrecruiter_remaining_quota}</td>
                      <td>{Event.offers}</td>
                      <td>{Event.days_remaining}</td>
                      <td>{Event.plan_start_date}</td>
                      <td>
                        <span
                          className={`badge badge-lg light badge-${
                            Event.published == "1" ? "success" : "danger"
                          }`}
                        >
                          {Event.published == "1" ? "Active" : "InActive"}
                        </span>
                      </td>
                      <td>
                        <div className="d-flex justify-content-end">
                          <div title="Manage Sub Recruiter" className="mr-2">
                            <Link
                              to={"#"}
                              onClick={(e) => handleSubRClick(e, Event.id)}
                              className="btn btn-secondary light mr-2"
                            >
                              MSR
                            </Link>
                          </div>
                          <div title="View Jobs" className="mr-2">
                            <Link
                              to={"#"}
                              className="btn btn-secondary light mr-2"
                              onClick={(e) => handleJobsClick(e, Event.id)}
                            >
                              View Jobs
                            </Link>
                          </div>

                          <div className="action-buttons d-flex justify-content-end">
                            <Link
                              to={"/" + Event.id + "/plan-history"}
                              className="btn btn-warning light mr-2"
                              //onClick={() => handleEditClick(Event.id)}
                            >
                              <i className="fa fa-history"></i>
                            </Link>
                            <Link
                              to={"#"}
                              className="btn btn-secondary light mr-2"
                              onClick={() => handleEditClick(Event.id)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24px"
                                height="24px"
                                viewBox="0 0 24 24"
                                version="1.1"
                                className="svg-main-icon"
                              >
                                <g
                                  stroke="none"
                                  strokeWidth="1"
                                  fill="none"
                                  fillRule="evenodd"
                                >
                                  <rect
                                    x="0"
                                    y="0"
                                    width="24"
                                    height="24"
                                  ></rect>
                                  <path
                                    d="M8,17.9148182 L8,5.96685884 C8,5.56391781 8.16211443,5.17792052 8.44982609,4.89581508 L10.965708,2.42895648 C11.5426798,1.86322723 12.4640974,1.85620921 13.0496196,2.41308426 L15.5337377,4.77566479 C15.8314604,5.0588212 16,5.45170806 16,5.86258077 L16,17.9148182 C16,18.7432453 15.3284271,19.4148182 14.5,19.4148182 L9.5,19.4148182 C8.67157288,19.4148182 8,18.7432453 8,17.9148182 Z"
                                    fill="#000000"
                                    fillRule="nonzero"
                                    transform="translate(12.000000, 10.707409) rotate(-135.000000) translate(-12.000000, -10.707409) "
                                  ></path>
                                  <rect
                                    fill="#000000"
                                    opacity="0.3"
                                    x="5"
                                    y="20"
                                    width="15"
                                    height="2"
                                    rx="1"
                                  ></rect>
                                </g>
                              </svg>
                            </Link>
                            <Link
                              to={"#"}
                              className="btn btn-danger light"
                              onClick={() => handleDeleteClick(Event.id)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24px"
                                height="24px"
                                viewBox="0 0 24 24"
                                version="1.1"
                                className="svg-main-icon"
                              >
                                <g
                                  stroke="none"
                                  strokeWidth="1"
                                  fill="none"
                                  fillRule="evenodd"
                                >
                                  <rect
                                    x="0"
                                    y="0"
                                    width="24"
                                    height="24"
                                  ></rect>
                                  <path
                                    d="M6,8 L6,20.5 C6,21.3284271 6.67157288,22 7.5,22 L16.5,22 C17.3284271,22 18,21.3284271 18,20.5 L18,8 L6,8 Z"
                                    fill="#000000"
                                    fillRule="nonzero"
                                  ></path>
                                  <path
                                    d="M14,4.5 L14,4 C14,3.44771525 13.5522847,3 13,3 L11,3 C10.4477153,3 10,3.44771525 10,4 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z"
                                    fill="#000000"
                                    opacity="0.3"
                                  ></path>
                                </g>
                              </svg>
                            </Link>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <>
                    <tr>
                      <td colSpan="100%" className="text-center">
                        {" "}
                        No Record Found.
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table> */}
            <DataTable
              //className="table display dataTablesCard job-table table-responsive-xl card-table dataTable no-footer"
              columns={columns}
              data={data}
              progressPending={loading}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              paginationRowsPerPageOptions={[
                10, 20, 30, 50, 100, 200, 500, 1000, 1500, 2000,
              ]}
              onChangePage={handlePageChange}
              selectableRows
              persistTableHead
              onSelectedRowsChange={({ selectedRows }) =>
                setSelectedRows(selectedRows)
              }
              subHeader
              subHeaderComponent={
                <SearchInputComponent setFilterText={handleSearchText} />
              }
              clearSelectedRows={toggleCleared}
              onSort={handleSort}
              sortServer
              fixedHeader={true}
              fixedHeaderScrollHeight={"500px"}
            />
          </div>
        </div>
      </div>

      <Modal
        className="modal fade"
        size="lg"
        show={addModel}
        backdrop="static"
        onHide={setAddModal}
      >
        <div role="document">
          <div className="modal-header">
            <h4 className="modal-title fs-20">Search</h4>
            <button
              type="button"
              className="btn-close"
              onClick={() => setAddModal(false)}
              data-dismiss="modal"
            >
              <span></span>
            </button>
          </div>
          <div className="modal-body p-1">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="formGroupExampleInput">Start date</label>
                    <div className="mb-1 form-group">
                      <DatePicker
                        className={`form-control`}
                        wrapperClassName="d-inline"
                        dateFormat="Y-MM-dd"
                        maxDate={new Date()}
                        peekNextMonth
                        isClearable
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Select date"
                        //selected={reqParams?.registered_after}
                        onFocus={(e) => e.target.blur()}
                        selected={
                          advFields?.start_date ? advFields?.start_date : ""
                        }
                        onChange={(date) => {
                          setAdvFields({
                            ...advFields,
                            start_date: date ? date : "",
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="formGroupExampleInput">End date</label>
                    <div className=" mb-1 form-group">
                      <DatePicker
                        className={`form-control`}
                        wrapperClassName="d-inline"
                        dateFormat="Y-MM-dd"
                        maxDate={new Date()}
                        isClearable
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Select date"
                        //selected={reqParams?.registered_after}
                        onFocus={(e) => e.target.blur()}
                        selected={
                          advFields?.end_date ? advFields?.end_date : ""
                        }
                        onChange={(date) => {
                          setAdvFields({
                            ...advFields,
                            end_date: date ? date : "",
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="formGroupExampleInput">
                      Recruiter type
                    </label>
                    <div className="input-group mb-1 form-group">
                      <select
                        className="form-select"
                        name="recruiter_type"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            recruiter_type: e.target.value,
                          })
                        }
                        defaultValue={advFields?.recruiter_type}
                      >
                        <option value="">Select Type</option>
                        <option value="1">Regular Recruiter</option>
                        <option value="2">Internship Recruiter</option>
                        {/* {companies &&
                          companies?.length > 0 &&
                          companies.map((company) => (
                            <option key={company.id} value={company.id}>
                              {company.company_name}
                            </option>
                          ))} */}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="formGroupExampleInput">Plan Category</label>
                    <div className="input-group mb-1 form-group">
                      <select
                        className="form-select"
                        name="recruiter_type"
                        onChange={(e) => {
                          setAdvFields({
                            ...advFields,
                            category_id: e.target.value,
                          });
                        }}
                        defaultValue={advFields?.category_id}
                      >
                        <option value="">Select Category</option>
                        {Object.keys(categories).map((val, i) => {
                          return (
                            <option value={val} key={val}>
                              {categories[val].name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="formGroupExampleInput">Plan</label>
                    <div className="input-group mb-1 form-group">
                      <select
                        className="form-select"
                        name="recruiter_type"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            plan_id: e.target.value,
                          })
                        }
                        defaultValue={advFields?.plan_id}
                      >
                        <option value="">Select Plan</option>
                        {/* {planById(advFields?.category_id)} */}
                        {plnList.map((cat) => (
                          <option value={cat.plan_id} key={cat.plan_id}>
                            {cat.plan_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="candidate_status">Status</label>
                    <div className="input-group mb-3 form-group">
                      <select
                        id="published"
                        className="form-select"
                        type="text"
                        name="published"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            published: e.target.value,
                          })
                        }
                        defaultValue={advFields?.published}
                      >
                        <option value="">Please Select</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="submit"
              className="btn btn-success"
              onClick={onSaveAdvanceSearch}
            >
              Search
            </button>
            <button
              type="button"
              onClick={() => setAddModal(false)}
              className="btn btn-danger"
            >
              <i className="flaticon-delete-1"></i> Close
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default RLists;
